/*
 * ギフトラッピングページ: URL に from=cart がある時だけ「カートに戻る」ボタンを表示する。
 * 読み込み元: sections/main-page.liquid（page.handle == 'gift-wrapping' の時のみ）
 * スタイル: assets/gift-wrapping-cart-cta.css
 */
(function () {
  if (new URLSearchParams(window.location.search).get('from') !== 'cart') return;
  var page = document.querySelector('.p-page--gift-wrapping');
  if (page) page.classList.add('is-from-cart');
})();
